import styled from 'styled-components'

export const Container = styled.div`
  background: #f3f2f2;
  padding: 0 1.2rem;
  height: 42px;
  width: 100%;
  display: flex;
  align-items: center;
  .breadcrumb-line {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
  .breadcrumb-line .parent {
    font-size: 0.85rem;
    font-weight: 500;
    color: ${props => (props.theme.name === 'light' ? '#9ca3af' : '#9aa5ad')};
  }
  .breadcrumb-line button.link {
    background: none;
    border: none;
    padding: 0;
    font-family: inherit;
    cursor: pointer;
    &:hover {
      color: ${props => props.theme.colors.primary};
      text-decoration: underline;
    }
  }
  .breadcrumb-line .sep {
    font-size: 0.85rem;
    color: ${props => (props.theme.name === 'light' ? '#d1d5db' : '#5a6773')};
  }
  .breadcrumb-line .current {
    font-size: 1.05rem;
    font-weight: 700;
    color: ${props => (props.theme.name === 'light' ? '#1f2937' : '#eee')};
  }
  @media screen and (max-width: 650px) {
    .breadcrumb-line .parent,
    .breadcrumb-line .sep {
      display: none;
    }
  }
`
